import { Component, OnInit, AfterViewInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { Observable, Subject, Subscription, BehaviorSubject, ReplaySubject } from "rxjs";

interface ObjectOfArrays {
  [key: string]: any[];
}

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  //Collection properties
  @Input('collection') collection: Subject<any>;
  @Input('filters') allowedFilters: string[];
  @Input('collectionEvents') collectionEvents: Subject<any>;

  public collectionSub: Subscription;
  public collectionEventsSub: Subscription;
  public __collection: Array<any> = [];
  public filteredCollectionData: Array<any> = [];
  public columns: Array<any> = [];
  public columnsData: Array<any> = [];
  public exclude_columns: Array<any> = [];

  @Input('selectionActions') selectionActions: Array<any>;
  @Output('actOnSelection') selectionActionEmitter = new EventEmitter<any>();
  @Output('matches') matches: Array<number>;

  //Filter properties
  public availableFilters: Array<any> = [];
  public selectedFilters: Array<any> = [];

  //Varous options
  @Input() paginated: boolean = false;
  public ready: boolean = false;
  public defaultColumns: Array<any>;

  public selectizeConfig: any = {
    multiple: true,
    allowClear: true,
    closeOnSelect: true,
    placeholder: 'Filter'
  };
  public selectedFiltersInput: any;

  constructor() {}

  ngOnInit() {
    if ( !(this.collection instanceof Observable) ) {
      console.error('`collection` is not an instance of Rx.Observable!');
    }

    this.defaultColumns = [
      {
        width: 30,
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizeable: false,
      }
    ];

    if (this.columns) {
      this.columnsData = this.columns.filter( (column) => !column.exclude_from_list );
      this.columnsData.forEach((column) => {
          if (!column.width) {
           column.width = 60;
          }
        });
      this.columnsData = this.defaultColumns.slice().concat(this.columnsData);
    }

    this.collectionSub = this.collection.subscribe((data) => {
      if (data) {
        this.__collection = JSON.parse(JSON.stringify(data.slice()));
        this.updateCollectionData();
        if (this.columns) {
          this.columnsData = this.columns.filter( (column) => !column.exclude_from_list );
          this.columnsData = this.defaultColumns.slice().concat(this.columnsData);
        };
        this.ready = true;
      }
    });

    if (this.collectionEvents) this.collectionEventsSub = this.collectionEvents.subscribe((data: Array<any>) => {
      if (data) {
        data.forEach((d) => {
          if (d.id) {
            let match = this.__collection.find((c) => c.id == d.id);
            if (match) match = Object.assign(match, d);
          }
        });
        this.filterCollection();
        this.refresh();
      }
    });

  }

  ngOnDestroy() {
    if (this.collectionSub) this.collectionSub.unsubscribe();
  }

  private updateCollectionData() {
    this.availableFilters = [];
    let column_object = {};
    this.__collection.map((item) => {
      for (let key in item) {
        if (
          item.hasOwnProperty(key) &&
          !(this.exclude_columns && this.exclude_columns.indexOf(key) >= 0) &&
          this.allowedFilters.includes(key) &&
          key !== 'id' && key !== 'created_at' && key !== 'updated_at' &&
          item[key] !== null && !(item[key] instanceof Object)) {

          if (this.columns) {
            let ogColumn = this.columns.find((obj) => obj.prop === key);
            if (ogColumn && ogColumn.formatter !== undefined) {
              item[key] = ogColumn.formatter(item[key]); // apply formatter from options
            }
          }

          if (column_object[key] === undefined) {
              column_object[key] = [];
          }

          if (column_object[key].indexOf(item[key]) === -1) {
            column_object[key].push(item[key]);
          }

        }
      }

      return item;
    });

    if (!this.columns) {
      this.columnsData = Object.keys(column_object).map((column) => {
        return { prop: column };
      });
      this.columnsData = this.defaultColumns.slice().concat(this.columnsData);
    }

    let newFilters: Array<any> = [];
    for (let column in column_object) {
      let formattedColumn = column;
      let exclude_from_filter = false;

      if (this.columns) {
        let ogColumn = this.columns.find((obj) => obj.prop === column);

        if (ogColumn) {
          formattedColumn = ogColumn.name ? ogColumn.name : column;
          exclude_from_filter = ogColumn.exclude_from_filter;
        }
      }

      if (!exclude_from_filter) {
        column_object[column].forEach((value) => {
          let newFilter = { id: formattedColumn + ',' + value, name: this.humanize(formattedColumn) + ': ' + value, column: column, value: value }
          let match = this.availableFilters.find((f) => {
						return f.id === newFilter.id && f.name === newFilter.name && f.column === newFilter.column && f.value === newFilter.value;
          });
          if (typeof match === 'undefined') {
            newFilters.push(newFilter);
          }
        });
      }
    }
    this.availableFilters = this.availableFilters.concat(newFilters);

    this.filterCollection();
  }

  updateSelectedFilters(e) {
    this.selectedFilters = e.data.reduce((selected, filter) => {
      if (selected[filter.column] === undefined) selected[filter.column] = [];
      selected[filter.column].push(filter.value);
      return selected;
    }, {});

    this.filterCollection();
  }

  filterCollection() {
    this.filteredCollectionData = Object.keys(this.selectedFilters).length === 0 ? this.__collection :
      this.__collection.filter((item) => {
        let pass = false;
        for (let filter in this.selectedFilters) {
          if (this.selectedFilters.hasOwnProperty(filter) && item[filter] !== undefined) {
            if (!pass) pass = this.selectedFilters[filter].indexOf(item[filter]) >= 0;
          }
        }

        return pass;
      });
  }

  actOnSelection(event) {
    if (!this.selectedFilters.length) {
      this.selectionActionEmitter.emit(false);
    } else {
      let matches: Array<number> = [];
      this.__collection.forEach((item) => {
        let match: boolean = this.selectedFilters.reduce((match, filter) => {
          filter = filter.split(',');
          if (filter[0] === 'online') filter[1] = filter[1] === 'true';
          return match || item[filter[0]] == filter[1];
        }, false);
        if (match) matches.push(item.id);
      });
      this.selectionActionEmitter.emit(matches);
      this.matches = matches;
    }
  }

  humanize(str) {
    var i, frags = str.split('_');
    for (i=0; i<frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
    return frags.join(' ');
  }

  public refresh() {
    this.filteredCollectionData = JSON.parse(JSON.stringify(this.filteredCollectionData.slice()));
  }

  displayCheck(row) {
    return !row.hideEditDelete;
  }

  getId(row) {
    return row.id;
  }

}
